import {useEffect, useState} from "react";

export function useDebounce<T>(value: T, delay: number) {

  const [debounceValue, setDebounceValue] = useState<any>(value);

  useEffect(() => {

    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounceValue;
}